module.exports = __webpack_public_path__ + "static/media/arrow-left-circle.f1de79cb.svg";